import { TooltipDesignTokens } from '@primeuix/themes/types/tooltip';

export const tooltip: TooltipDesignTokens = {
  colorScheme: {
    dark: {
      root: {
        background: '{blue.300}',
        maxWidth: '300px',
      },
    },
  },
};
